import { useParams } from "react-router-dom";

/** 讀取並轉換路由參數為整數，`required` 為 true 時參數缺漏或非數字會拋錯 */
export default function useIntRouteParam<T extends boolean = false>(
  name: string,
  required?: T,
): T extends true ? number : number | undefined {
  const params = useParams();
  const value = params[name]?.trim();

  if (!value && required) {
    throw new Error(`Missing route param: ${name}`);
  }

  if (value) {
    const parsedValue = parseInt(value, 10);
    if (Number.isNaN(parsedValue)) {
      throw new Error(`Invalid route param: ${name}`);
    }
    return parsedValue as T extends true ? number : number | undefined;
  }
  return undefined as T extends true ? number : number | undefined;
}
